if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

$(document).ready(function(){

  
  var Variantoption_INTERVAL = setInterval(function(){
    // Check if element exist
    if($('.mw-option').length > 0){
        // Since element is created, no need to check anymore
        clearInterval(Variantoption_INTERVAL);
        var option_number = 1;
        $('.mw-option:not(.mw-hidden)').each(function(){
           $(this).find('.mw-stack__item .mw-text--style-strong').prepend('<span class="mw-option-numbertxt">'+option_number+'.</span> ');
           option_number = option_number + 1;
        });
        $('.block__complete-set-heading').find('span').text(option_number+'.');

        
        $('.mw-option input.mw-option__control').click(function(){
          var option_number = 1;
          setTimeout(function(){
            $('.mw-option:not(.mw-hidden)').each(function(){
              $(this).find('.mw-stack__item .mw-text--style-strong').find('.mw-option-numbertxt').remove();
              $(this).find('.mw-stack__item .mw-text--style-strong').prepend('<span class="mw-option-numbertxt">'+option_number+'.</span> ');
              option_number = option_number + 1;
            });
          },100);
          
        });
    }
  }, 1000);

  $(".product__accordion .accordion__content a[href^='#']").click(function(event) {
    event.preventDefault();
    var hash = this.hash;
    $('html, body').animate({scrollTop: $(hash).offset().top - 250}, 1200);
  });

  $('.product__accordion .product-accordation-desc[data-accordiondesc="true"]').click(function(event) {
    event.preventDefault();
    $('html, body').animate({scrollTop: $("#block__product--description-section").offset().top - 200}, 1000);
  });

  $('.block__complete-set-productcheckbox input[type="checkbox"]').click(function(){
    if($(this).prop('checked')==true){
      $(this).parents('.block__complete-set-product').addClass('added-to-set');
    }else{
      $(this).parents('.block__complete-set-product').removeClass('added-to-set');
    }
  });

  $(".product-formcontent-tabcontent a.product-formcontent-tabtitle[href^='javascript:void(0)']").click(function(event) {
    event.preventDefault();
    $(".product-formcontent-tabcontent .product-formcontent-tabwrap").removeClass('active-formtab');
    var hash = this.dataset.producttabtitle;
    $(this).parents('.product-formcontent-tabwrap').addClass('active-formtab');
    $('html, body').animate({scrollTop: $('.block__oriflamme-description-section[data-producttabcontent="'+hash+'"]').offset().top - 200}, 1200);
  });

  if($('.product-form__input.productform-variantinput-swatchvalopt').length == 0){
    $('.product-form__input input[type="radio"]').change(function(){
      var inputall_value = '';
        $('fieldset.product-form__input').each(function(){
          if(inputall_value == ''){
            inputall_value = $(this).find('input[type="radio"]:checked').attr('data-inputval');
          }else{
            inputall_value = inputall_value +'-'+ $(this).find('input[type="radio"]:checked').attr('data-inputval');
          }
        });
        $('.product-variant-vallabel .product-variant-valprice').text('+$0.00');
        var current_variant_price = $('select.variant-allopt').find('option[data-varianttitle="'+inputall_value+'"]').attr('data-variantprice');
        $('.product-variant-vallabel[data-swtachvalopt="'+$(this).attr('data-inputval')+'"]').find('.product-variant-valprice').css('display','flex');
        $('.product-variant-vallabel[data-swtachvalopt="'+$(this).attr('data-inputval')+'"]').find('.product-variant-valprice').text('+'+current_variant_price);
    })
  }else{}

  function variant_pricebox(){
    var swatchValue = [];
    $('.product-variant-vallabel.product-variant-swatchvallabel').each(function(){
      if($(this).prev('input[type="radio"]').is(":checked")){
        swatchValue.push( {
          inputval: $(this).parents('fieldset.product-form__input').find('input[type="radio"]:checked').attr('data-inputval'),
          inputindex: $(this).parents('fieldset.product-form__input').find('input[type="radio"]:checked').attr('data-optindex')
        });
      }else{}
    });

    if($('.product-variant-vallabel.product-variant-swatchvallabel').length > 0){
      $('.main-product-oriflammegas-wrapper .product-variant-valprice').css('display','flex');
      $('fieldset.product-form__input .product-variant-vallabel:not(.product-variant-swatchvallabel)').each(function(){
        var current_val = $(this).attr('data-swtachvalopt');
        var curernt_index = $(this).attr('data-optindex');
          var swatchBoxval = [];
          swatchBoxval.push({
            inputval: current_val,
            inputindex: curernt_index
          });

          var swatchAllval = swatchValue.concat(swatchBoxval);

          var swatchresultArray = [];
          $.each(swatchAllval, function(index, item) {
            var arrayIndex = parseInt(item.inputindex) - 1;
            swatchresultArray[arrayIndex] = item.inputval;
          });
          var swatchresultval = swatchresultArray.toString().replaceAll(',','-');
          var finalstring = $('select.variant-allopt').find('option[data-varianttitle="'+swatchresultval+'"]').attr('data-variantprice');
          $(this).find('.product-variant-valprice').text('+'+finalstring);
      });
    }else{
    }

  }
  if($('body.templatename-product-oriflamme-gas').length > 0){
    variant_pricebox();
    $('.product-form__input input[type="radio"]').change(function(){
      variant_pricebox();
    });
  }

})